import React from "react";
import {AButton, ATriggerTooltip} from "@cisco-sbg-ui/magna-react";
import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";
import {setIncidentStatus} from "store/features/incidentsSlice";
import {selectIncidentDetail} from "store/selectors";
import {sendIncidentResponseCloseIncidentTelemetry} from "api/telemetry/incidentsTelemetrics";
import {STATUS_MAP} from "models/options";
import {getShortId} from "utils/misc";

export default function CloseIncidentButton({...rest}) {
  const {t} = useTranslation();
  const dispatch = useDispatch();
  const incident = useSelector(selectIncidentDetail);
  const {id, status} = incident;
  const disabled = status === STATUS_MAP.Closed.value;

  const closeIncident = () => {
    const shortId = getShortId(id);

    dispatch(
      setIncidentStatus({
        incidents: [{...incident}],
        status: STATUS_MAP.Closed.value
      })
    );
    sendIncidentResponseCloseIncidentTelemetry(shortId);
  };

  return (
    <ATriggerTooltip
      wrapperClass="d-inline-flex"
      placement="top"
      content={t("response.closeIncidentTooltip")}
      disabled={!disabled}
      wrapChildren>
      <AButton
        medium
        disabled={disabled}
        onClick={() => closeIncident()}
        {...rest}>
        {t("response.closeIncident")}
      </AButton>
    </ATriggerTooltip>
  );
}
